import { render, staticRenderFns } from "./OrderHead.vue?vue&type=template&id=426ed85b&scoped=true&"
import script from "./OrderHead.vue?vue&type=script&lang=js&"
export * from "./OrderHead.vue?vue&type=script&lang=js&"
import style0 from "./OrderHead.vue?vue&type=style&index=0&id=426ed85b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426ed85b",
  null
  
)

export default component.exports